import AppInput from '../AppInput';

export function AppInputFromArray({
    id,
    type,
    label,
    optionObject,
    register,
    errorMessage,
}) {
    return (
        <div>
            <AppInput
                errorMessage={errorMessage}
                id={id}
                label={label}
                optionObject={optionObject}
                register={register}
                type={type}
            />
            {errorMessage && (
                <p className="mt-2 text-sm text-red-600 dark:text-red-500 font-[500]">
                    {errorMessage}
                </p>
            )}
        </div>
    );
}
